import React, {
	useEffect,
	useState
} from 'react'

import {
	useDispatch, useSelector,
} from 'react-redux'

import {
	getWeeklyCompliance,
	getMonthlyCompliance,
	getComplianceInRange,
	updateDateRange,
	updateAccountFilterType,
	updateFilterEventType,
	selectGymFilters,
	selectTrainerFilters,
	updateAccountFilterConstraints,
	toggleNoDataFilter
} from './complianceSlice'

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import useAccountTypeName from '../../hooks/useAccountTypeName'




const sixDaysAgo = ()=>{
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate()-6);
}

const gymAggregateSelectOptions = [
	'gym', 'trainer', 'client'
]

const chainAggregateSelectOptions = [
	'chain', 'gym', 'trainer', 'client'
] 

const aggregateSelectOptionsMap = {
	chain:chainAggregateSelectOptions,
	gym: gymAggregateSelectOptions,
}

const accountTotals = (data, accountTypeFilter) => {
	//console.log(data)
	//console.log(accountTypeFilter)
	if(accountTypeFilter === 'chain'){
		return `${data?.gym_ids?.length} gyms - ${data?.trainer_ids?.length} trainers - ${data?.client_ids?.length} clients`
	}else if(accountTypeFilter === 'gym'|| accountTypeFilter === 'gyms'){
		return `${data?.trainer_ids?.length} trainers - ${data?.client_ids?.length} clients`
	}else if(accountTypeFilter === 'trainer'|| accountTypeFilter === 'trainers'){
		return `${data?.client_ids?.length} clients`
	}else{
		return ''
	}
}

const capitalize = s => Boolean(s) ? `${s.charAt(0).toUpperCase()}${s.slice(1)}` : ''

const SubAccountFilters = ({accounts,parentAccountType,defaultValue}) =>{
	const dispatch = useDispatch()
	return (
		<Form.Control
			onChange={e=>dispatch(updateAccountFilterConstraints({
				constraint:e.target.value,
				type:parentAccountType
			}))} 
			value={defaultValue}
			as="select" 
			size="sm"
			custom>
			<option value="all">All {capitalize(parentAccountType)}s</option>
			{
				parentAccountType==='trainer'&&
				<option value="shared">Shared Clients</option>
			}
			{accounts?.map(account=>(
				<option 
					key={account.user_id_number} 
					value={account.user_id_number}>
					{account.user_name} ({accountTotals(account,parentAccountType)})
				</option>
			))}
		</Form.Control>
	)
}


const Filters = props =>{
	const dispatch = useDispatch()
	const currentUserAccountType = useSelector(state => state.users.current_user.account_type)
	const user = useSelector(state => state.users.current_user.isMAXUser)
	const [showTagManger,setShowTagManger] = useState(false)
	const gymAccountName = useAccountTypeName('gym')
	const accountTypeFilter = useSelector(state=>state.compliance.filters.account.type)
	const status = useSelector(state=>state.compliance.status)
	const isMAXUser = Boolean(useSelector(state=>state.users.current_user.isMAXUser))
	const [fromDate,setFromDate] = useState(sixDaysAgo())
	const [toDate,setToDate] = useState(new Date())
	const eventType = useSelector(state=>state.compliance.filters.eventType)
	const dateRange = useSelector(state=>state.compliance.filters.dateRange)
	const hideNoData = useSelector(state=>state.compliance.filters.hideNoData)
	const [isFilterLoading, setIsFilterLoading] = useState(false);
	const displayKeys = {
		all:['workout','task','nutrition','simplified_nutrition'],
		workout:['workout'],
		task:['task'],
		nutrition:['nutrition'],
		simplified_nutrition:['simplified_nutrition']
	}[eventType]
	const aggregateSelectOptions = aggregateSelectOptionsMap[currentUserAccountType]
	const gyms = useSelector(selectGymFilters)
	const defaultGym = useSelector(state=>state.compliance.filters.account.constraints.gym)
	const trainersByGym = useSelector(selectTrainerFilters)
	const defaultTrainer = useSelector(state=>state.compliance.filters.account.constraints.trainer)
	const dataSelectOptions = [
		{
			text:'All Data',
			value:'all'
		},{
			text:'Workouts',
			value:'workout'
		},{
			text:'Tasks',
			value:'task'
		},{
			text:'Nutrition',
			value:'nutrition'
		},{
			text:isMAXUser?"MAX Nutrition":"Simplified Nutrition",
			value:'simplified_nutrition'
		}
	]

	const customRangeHandler = ()=>{
		const from_date = fromDate.toISOString().slice(0,10)
		const to_date = toDate.toISOString().slice(0,10)
		dispatch(getComplianceInRange({
			from_date,
			to_date
		}))
	}

	const AccountTypeCheck = ({ fitswAccountType }) => {
		const resolvedAccountType = useAccountTypeName(fitswAccountType)
		const dispatch = useDispatch()
		return (
			<Form.Check
				onChange={
					e=>dispatch(updateAccountFilterType(e.target.value))
				} 
				id={`account-option-${fitswAccountType}`}
				type="radio"
				className="mr-3 mb-1"
				key={fitswAccountType} 
				name="account-options" 
				label={capitalize(resolvedAccountType)}
				value={fitswAccountType}
				checked={fitswAccountType===accountTypeFilter}
			/>
		)
	}

	
	useEffect(()=>{
		setIsFilterLoading(true);
		dispatch(updateAccountFilterType(currentUserAccountType))
		dispatch(getMonthlyCompliance())

		const from_date = fromDate.toISOString().slice(0,10)
		const to_date = toDate.toISOString().slice(0,10)
		dispatch(getComplianceInRange({from_date,to_date}))
		
		dispatch(getWeeklyCompliance())
		.then(res => {
			setIsFilterLoading(false)
		})

	},[currentUserAccountType])
	return (
		<div>
			<div className="d-flex flex-wrap align-items-center mb-1">
				<div>
					<strong>Account Type</strong>
					<div className="d-flex flex-wrap">
						{aggregateSelectOptions.map(opt => (
							<AccountTypeCheck fitswAccountType={opt} />
						))}
					</div>
				</div>
				<span className="mx-3"></span>
				<div>
					<strong>Filter Data</strong>
					<div className="d-flex flex-wrap">
						{dataSelectOptions.map(opt=>(
							<Form.Check 
								onChange={
									e=>dispatch(updateFilterEventType(e.target.value))
								} 
								id={`account-option-${opt.value}`}
								type="radio"
								className="mr-3 mb-1"
								key={opt.value} 
								name="data-options" 
								label={opt.text} 
								value={opt.value} 
								checked={opt.value===eventType}/>
						))}
					</div>
				</div>
			</div>
			
			{
				['trainer','client'].includes(accountTypeFilter)&&
				<div>
					<div className="d-flex mb-3">
						{
							(['trainer','client'].includes(accountTypeFilter) && currentUserAccountType === 'chain')&&
							<SubAccountFilters parentAccountType="gym" defaultValue={defaultGym} accounts={gyms}/>
						}
						{
							accountTypeFilter==='client'&&
							<SubAccountFilters parentAccountType="trainer" defaultValue={defaultTrainer} accounts={trainersByGym}/>
						}
					</div>
				</div>
			}
			<div className="d-flex align-items-center flex-wrap mb-3">
				<ButtonGroup className="mr-2 my-1">
					<Button 
						onClick={()=>{
							dispatch(getWeeklyCompliance({refresh:1}))
							dispatch(getMonthlyCompliance({refresh:1}))
							const from_date = fromDate.toISOString().slice(0,10)
							const to_date = toDate.toISOString().slice(0,10)
							dispatch(getComplianceInRange({
								from_date,
								to_date
							}))
						}}
						variant="outline-dark"
						size="sm">
						<i className="fas fa-redo"/>
					</Button>
					<Button 
						onClick={()=>dispatch(updateDateRange('weekly'))}
						variant={dateRange==='weekly'?"dark":"outline-dark" }
						size="sm">
						7 days
					</Button>
					<Button 
						onClick={()=>dispatch(updateDateRange('monthly'))}
						variant={dateRange==='monthly'?"dark":"outline-dark" }
						size="sm">
						30 days
					</Button>
					<Button 
						onClick={()=>dispatch(updateDateRange('custom'))}
						variant={dateRange==='custom'?"dark":"outline-dark" } 
						size="sm">
						Custom
					</Button>
				</ButtonGroup>
				{dateRange==='custom'&&
					<div className="d-flex align-items-center flex-wrap my-1">
						<div className="d-flex">
							<DatePicker 
								selected={fromDate}
								onChange={(date)=>{
									setFromDate(date)
								}}
								customInput={<input style={{width:'100px',height:'31px',lineHeight:'31px'}}/>}
								className="mr-1 text-center border rounded" 
								placeholder="subscribe"/>
							<DatePicker 
								selected={toDate}
								onChange={(date)=>{
									setToDate(date)
								}}
								customInput={<input style={{width:'100px',height:'31px',lineHeight:'31px'}}/>}
								className="mr-1 text-center border rounded" 
								placeholder="subscribe"/>
						</div>
						<Button 
							onClick={customRangeHandler} 
							disabled={status==='loading'} 
							variant="outline-dark" size="sm">
							{	
								status==='loading'?
								<Spinner size="sm" animation="border"/>:
								'apply'
							}
						</Button>
					</div>
				}
				<Form.Check 
					onChange={
						e=>dispatch(toggleNoDataFilter())
					} 
					checked={hideNoData}
					id={`hide-no-data`}
					className="ml-auto my-1"
					label="Hide accounts with no data"/>
			</div>
		</div>
	)

}

export default Filters